<template>
  <chart-canvas :option="option" :empty="empty" />
</template>

<script>
import ChartCanvas from "./ChartCanvas.vue";
import { countryPieOption } from "./chart-options";

export default {
  name: "CountryPieChart",
  components: { ChartCanvas },
  props: { rows: { type: Array, default: () => [] } },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
    };
  },
  computed: {
    empty() {
      return !this.rows.length;
    },
    option() {
      return countryPieOption(this.rows, this.isMobile);
    },
  },
  mounted() {
    window.addEventListener("resize", this.syncViewport);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.syncViewport);
  },
  methods: {
    syncViewport() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>
